import React from 'react';
import BaseTestCard from '../BaseTestCard/BaseTestCard';
import TestSelectionFormFieldNames from '../../../../../../Models/TestSelectionFormFieldNames';
import TestInfo from '../../../../../../../../Models/TestInfo';
import { resourceBaseUrl } from '@/AppSettings';
import { PreviewQuestionsProps } from '../PreviewQuestions/Dialog/usePreviewQuestions';

interface SkillsTestCardProps extends Omit<PreviewQuestionsProps, 'testType'> {
    test: TestInfo;
}

function SkillsTestCard({ test, demoQuestions, likertOptions }: SkillsTestCardProps): React.JSX.Element {
    return (
        <BaseTestCard
            {...test}
            testName={test.jobFunctionName}
            fieldName={TestSelectionFormFieldNames.isSkillsSelected}
            imageURL={`${resourceBaseUrl}/images/Skills.png`}
            demoQuestions={demoQuestions}
            likertOptions={likertOptions}
        />
    );
}

export default SkillsTestCard;
